import { readerPath } from "../modules/env/baseUrl";

export type ViteMode = "development" | "staging" | "production";

interface ExtendedImportMetaEnv extends ImportMetaEnv {
  DEV: boolean;
  MODE: ViteMode;
  VITE_DICTIONARY_URL: string;
  DEBUG_LOAD_TIME?: "true";
}

const env = import.meta.env as ExtendedImportMetaEnv;
export const DEV = env.DEV;
export const MODE = env.MODE;

export const BASE = readerPath("/_proxy");
export const SENTRY_DSN =
  "https://b614f77e745c471a9a9fe2f6925f8f8f@o37564.ingest.sentry.io/4503902743560192";
export const SENTRY_ERROR_SAMPLE_RATE = 1.0;
export const SENTRY_TRACES_SAMPLE_RATE = 0.1;
// keep the boot window free of Sentry requests
export const SENTRY_SEND_DELAY = 1000;
